/**
 * Card — conteneur stylisé réutilisable.
 */
import { colors } from "../styles/tokens";

export default function Card({ children, hover = false, style = {}, onClick = null, ...rest }) {
  const baseStyle = {
    background: colors.card,
    border: `1px solid ${colors.border}`,
    borderRadius: "14px",
    padding: "20px",
    transition: "all 200ms",
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  return (
    <div
      style={baseStyle}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (hover || onClick) {
          e.currentTarget.style.borderColor = colors.goldBorder;
          e.currentTarget.style.transform = "translateY(-2px)";
        }
      }}
      onMouseLeave={(e) => {
        if (hover || onClick) {
          e.currentTarget.style.borderColor = colors.border;
          e.currentTarget.style.transform = "translateY(0)";
        }
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
